import React, { HTMLAttributes, ReactNode } from 'react';
import { ButtonProps } from 'react-bootstrap';

import cx from 'classnames';

import LinkButton from 'components/LinkButton/LinkButton';
import { ILink } from 'models/link';

interface LinkButtonRowProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode; // Add children for React 18
  links: ILink[];
  btnProps?: ButtonProps;
}

const defaultBtnProps = {
  className: 'mr-2 mb-2',
  variant: 'danger' as const, // Add 'as const' for type safety
};

const LinkButtonRow: React.FC<LinkButtonRowProps> = ({
  links,
  btnProps = {},
  className = 'mb-n2 mt-3',
  ...props
}) => {
  // Fixed: Merge btnProps correctly
  const finalBtnProps = { ...defaultBtnProps, ...btnProps };

  return links?.length ? (
    <div className={cx(className, 'mb-n2')} {...props}>
      {links.map(link => (
        <LinkButton
          {...finalBtnProps}
          className={cx(finalBtnProps.className, 'mb-2')}
          key={link.id}
          link={link}
        />
      ))}
    </div>
  ) : null; // Return null instead of empty fragment
};

export default LinkButtonRow;
